import React from 'react';

import EmptyPage from './EmptyPage';

export const RedirectingPage = () => <EmptyPage title="Redirecting..." />;

export default RedirectingPage;



// WEBPACK FOOTER //
// ./src/components/common/RedirectingPage.js